<template>
  <v-list id="pois_list" two-line v-if="data.length > 0">
    <template v-for="(item, index) in sortedData">
      <v-list-item :key="index.id"  @click="openModal(item)">
        <v-list-item-avatar >
              <v-icon>{{ setAvatar(i(item).tags, i(item).id) }}</v-icon>

            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title  class="gofrance-text baloo-text text-capitalize">  {{ i(item).name.fr }}</v-list-item-title >
                <v-list-item-subtitle> {{ i(item).city }} 	&bull; {{ i(item).value }} {{ $tc('points', i(item).value ) }}</v-list-item-subtitle>

              </v-list-item-content>


        <v-list-item-action>
          <v-list-item-action-text v-if="item.distance" >
            {{ formatDist(item.distance) }}
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <v-divider
            v-if="index + 1 < sortedData.length"
            :key="index"
          ></v-divider>
    </template>
    <v-alert v-if="sortedData.length == 0" color="teal darken-2" type="info">
    {{ $t('noPoints') }}
    </v-alert>

  </v-list>

</template>
<script>

export default {
  props: ['referentiel', 'data', 'filters'],
  data: () => ({

  }),
  methods: {
    openModal(item) {
        this.$store.dispatch('openDialog', {id: item.id, data: item.data()});
      },
      setAvatar(tags, id) {
          if (this.$store.getters.user.loggedIn && this.$store.getters.user.data.validations.map(v => v.point).includes(id)){
            return 'mdi-check';

          } else {
            if (tags.includes('FoodEstablishment')) {
              return 'mdi-silverware-fork-knife';
            }else if (tags.includes('BarOrPub') || tags.includes('BistroOrWineBar')) {
                return 'mdi-glass-cocktail';
            }  else if (tags.includes('Accommodation')) {
              return 'mdi-bed';
            } else if (tags.includes('Park')) {
              return 'mdi-tree';
            } else if (tags.includes('NightClub')) {
              return 'mdi-disc-player';
            } else if (tags.includes('Visit')) {
              return 'mdi-eye';
            } else if (tags.includes('Store')) {
              return 'mdi-store';
            }else if (tags.includes('Museum')) {
              return 'mdi-bank';
            } else if (tags.includes('Library')) {
              return 'mdi-library';
            } else if (tags.includes('SwimmingPool')) {
              return 'mdi-pool';
            } else if (tags.includes('Cinema')||tags.includes('Theater')) {
              return 'mdi-theater';
            } else if(tags.includes('TheaterEvent')){
              return 'mdi-drama-masks';
            } else if (tags.includes('Transporter')) {
              return 'mdi-car';
            } else if (tags.includes('RemarkableBuilding')) {
              return 'mdi-bank';
            }else if (tags.includes('SightseeingBoat')) {
              return 'mdi-ferry';
            }

            else {
              return 'mdi-eye';
            }
          }


      },
      i: function(item) {
        if(item.data().d) {
          return item.data().d;
        } else {
          return item.data();
        }
      },
    formatDist(d) {
      //Number.parseFloat(item.distance).toFixed(2)
      if (d < 1){
        return Number.parseFloat(d * 1000).toFixed(0)+' m';
      } else {
        return Number.parseFloat(d).toFixed(2)+' km';
      }
    },
    getTags(t) {

      let find_ref = this.referentiel().filter(r => r.n == t);
      if (find_ref.length > 0) {
        return find_ref[0].t;
      }
      /*switch (t) {
        case 'to_eat':
          r = ['FoodEstablishment'];
        break;

        case 'to_sleep':
          r = ['Accommodation'];
        break;

        case 'to_see':
          r = ['Product', 'Visit', 'Museum', 'CulturalSite','Store', 'NaturalSite'];
        break;

        case 'event':
          r = ['Event'];
        break;


      }
      return r;*/

    }
  },
  computed: {

    sortedData: function(){
      let x = null;
      if (this.filters[0] == 'others') {
        x = this.referentiel().reduce(function(list, ob){
      return list.concat(ob.t);
      }, []);
      }
      return this.data.slice().filter((f) => {
        if (this.filters[0] == 'all') {
          return true;
        } else if (this.filters[0] == 'others') {
          return f.data().tags.filter(t =>  !x.includes(t)).length == f.data().tags.length ;

        }  else {
          return f.data().tags.filter(z => this.getTags(this.filters[0]).includes(z)).length > 0;
        }
      }).sort((a, b) => { return a.distance - b.distance });
    }

  }
}
</script>
<style>
#pois_list {
  width: 100%;
}

</style>
